import { useState, useEffect } from 'react'
import axios from 'axios'
import { API_URL, Currency, FormatNumber, FLPKEY, config, UserCode, API_IMAGES, PKLIVE, Contact } from '../components/Include';
import { useSelector, useDispatch } from 'react-redux'
import { Alerts } from '../components/notify';
import { usePaystackPayment } from 'react-paystack';
import { useFlutterwave, closePaymentModal } from 'flutterwave-react-v3';
import './payment.css';

const Payment = () => {
  const student = useSelector((state: any) => state.rootReducer.student);
  const dispatch = useDispatch()
  const [activePaymentMethod, setActivePaymentMethod] = useState('Paystack');

  const skill = useSelector((state: any) => state.rootReducer.skill);

  const [errors, setErrors] = useState({
    errorMessage: '',
    is_loading: false
  });

    const handlePaystackFees =()=>{
        var amount = 0
        var amountToCharge = (0.015 * Number(skill?.course_code?.fees)) + 83
    if(Number(skill?.course_code?.fees) <2500){
    
        amount =  (Number(skill?.course_code?.fees)+ (amountToCharge)) * 100
    
    }else if(amountToCharge>2000){
            amount = (Number(skill?.course_code?.fees)+ (2000)) * 100
        }else{
            
        amount =  (Number(skill?.course_code?.fees)+ (amountToCharge+100)) * 100
        }
        return amount;
    }

    const handleFlutterwaveFees =()=>{
      var amount = 0
      
      var amountToCharge = ((0.038)*Number(skill?.course_code?.fees))
      amount =  (Number(skill?.course_code?.fees)+ (amountToCharge))
      return amount;

  }
  
    // Use activePaymentMethod state instead of a separate variable
   var amountTopay = (skill?.course_code && skill?.skill) ? (activePaymentMethod === 'Paystack' ? handlePaystackFees() : activePaymentMethod === 'Flutterwave' ? handleFlutterwaveFees() : Number(skill?.course_code?.fees)) : 0
    
    var txRef = (new Date()).getTime().toString();



    const paystackConfig = {
      reference: txRef,
      email: student.email_address,
      firstname:student.full_name,
    lastname:student.matric_no,
    phone:UserCode,
      amount: amountTopay,
      publicKey: PKLIVE,
      split_code:'SPL_5Yq0hYZqiv',
      metadata: {
        custom_fields: [
        {
          display_name: 'skill_code',
          variable_name: 'skill_code',
          value: skill?.skill?.skill_code,
        },
        {
          display_name: 'course_code',
          variable_name: 'course_code',
          value: skill.course_code.value,
        },
         {
          display_name: 'student_code',
          variable_name: 'student_code',
          value: student?.code,
        },
         {
          display_name: 'matric_no',
          variable_name: 'matric_no',
          value: student?.matric_no,
        },
      ]
      } 
      };

    const initializePayment = usePaystackPayment(paystackConfig);

//flutterwave payment
const flutterConfig = {
  public_key: FLPKEY,
  tx_ref: txRef,
  amount: amountTopay,
  currency: "NGN",
  country: "NG", 
  payment_options: 'card,mobilemoney,ussd',
  customer: {
    email: student.email_address,
    phone_number: UserCode||"",
    name: student.full_name + ' '+ student.matric_no,
  },
  customizations: {
    title: 'Entrepreneurship Development Center, NSUK', 
    description: 'Training Manual Fees',
    logo: API_IMAGES+'/edc.jpg',
  },
  subaccounts: [
    {
      id: "RS_1A69795ABBEA25EE8B1E73C11688532E",
      transaction_split_ratio: "10"
    },
    {
      id: "RS_BD2F1A4916F6BE96DA7A6118660E4A3F",
      transaction_split_ratio: "10"
    }
  ],
};

    const handleFlutterPayment = useFlutterwave(flutterConfig);

    const handleFlutterPay=()=>{

      handleFlutterPayment({
        callback: (response) => {
         if (response.status == "successful" ){

          handleSubmitPayment(response, 'Flutterwave', String(response.transaction_id))
          
        }else {
            window.location.reload()
            // redirect to a failure page.
        } 
        },
        onClose: () => {
          closePaymentModal(); 
        },

      });
}

     // Effect to update amountTopay when payment method changes
     const [calculatedAmount, setCalculatedAmount] = useState(0);
     
     useEffect(() => {
        // Recalculate amount when payment method changes
        const newAmount = activePaymentMethod === 'Paystack' ? handlePaystackFees() : handleFlutterwaveFees();
        setCalculatedAmount(newAmount);
     }, [activePaymentMethod, skill.course_code?.fees]);
     
     // Update amountTopay with the calculated value
     useEffect(() => {
        if (calculatedAmount > 0) {
          amountTopay = calculatedAmount;
        }
     }, [calculatedAmount]);







    const handleSubmitPayment=(response:any, mode:string, transaction:string)=>{
  

        //Loader here
        setErrors({...errors, is_loading:true})
        const fd = new FormData();
        var today = new Date().toISOString().slice(0,10);
let course_code = skill.course_code.value;

  fd.append('student_code', student.code);
  fd.append('application_code', course_code);
  fd.append('skill_code', skill.skill.skill_code);
  fd.append('amount_paid', String(skill.course_code.fees)); 

  fd.append('platform', mode);
  fd.append('payment_ref', txRef);
  fd.append('response', JSON.stringify(response, null, 2));
  fd.append('teller_number', transaction);
  fd.append('date_paid', today);
  fd.append('staff_create', student.full_name);


        let url = API_URL+'/student/invoice/payment';
       
          axios.post(url, fd, config).then((response:any)=>{
      
            if(response.data.status ===200){
      
              dispatch({
                type:'SET_RECORDS',
                name:'skill',
                data:{}
            })

        Alerts('success', response.data.message, 'Success')
        window.open('/app/get_printout/'+course_code, '_self')
      
            }else{
              Alerts('danger', response.data.message, 'Something went wrong')
              setInterval(()=>{
                window.location.href = '/app/skills'
              }, 3000)
            }
          })
          .catch((error)=>{
            Alerts('danger', error.message, 'Error')
            setInterval(()=>{
              window.location.href = '/app/skills'
            }, 3000)
          }).finally(()=>{
            setErrors({...errors, is_loading:false})
          }) 
        
      }



      //Paystack payment
  const onSuccess = (ref:any) => {
  
		handleSubmitPayment(ref, 'Paystack', ref.transaction)
   
	};
	
	const onClose = () => {
	//console.log('closed')
	} 



      useEffect(()=>{
        if(!skill.course_code || !skill.skill){
          
         window.location.href = '/app/skills'
        
      }
      }, [skill])

  return (
    <>
      {/* Loading Overlay */}
      {errors.is_loading && (
        <div className="overlay">
          <img src="/images/loader.svg" alt="loader" />
        </div>
      )}

      {/* Payment Container */}
      <div className="payment-container mt-4">
        {/* Payment Header */}
        <div className="payment-header">
          <h4>
            <i className="fa fa-credit-card me-2"></i>Skill - {skill.skill?.title}
          </h4>
         
        </div>

        {/* Payment Content */}
        <div className="payment-info-section">
          {/* Warning Alert */}
          <div className="payment-alert">
            <h5>
              <i className="fa fa-exclamation-triangle me-2"></i>
              If you had already made payment for manual, please do not attempt to make a repayment as such is not refundable. 
              
              
              You can visit  <a href="https://nsukedc.com/verify-payment" target="_blank">Verification Page</a> to verify your payment by entering reference number sent you via your email.
            </h5>
          </div>

          {/* Payment Information */}
          <div className="row">
            <div className="col-lg-8">
              <div className="payment-info-card">
                <div className="payment-info-header">
                  <h5 className="mb-0">Payment Details</h5>
                </div>
                <div className="payment-info-body">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="payment-info-group">
                        <span className="payment-info-label">Course</span>
                        <span className="payment-info-value">
                          {skill?.skill?.session+' '+ skill?.skill?.course_code+' - '+skill?.skill?.course_title}
                        </span>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="payment-info-group">
                        <span className="payment-info-label">Email Address</span>
                        <span className="payment-info-value">{student.email_address}</span>
                      </div>
                    </div>
                  </div>

{/* payment amount area  */}
                  <div className="payment-amount">
                    <div className="row align-items-center">
                      <div className="col-md-6">
                        <span className="payment-info-label text-white">Amount to Pay</span>
                        <span className="amount-value text-white">
                          {Currency}{activePaymentMethod === 'Paystack'
                            ? FormatNumber(amountTopay / 100)
                            : FormatNumber(amountTopay)}
                        </span>
                      </div>
                      <div className="col-md-6 text-md-end">
                        <div className="transaction-reference">
                          <span className="reference-label">Transaction Reference:</span>
                          <span className="reference-value">{txRef}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Payment Methods */}
                  <div className="payment-methods">
                    <div
                      className={`payment-method-card ${activePaymentMethod === 'Paystack' ? 'active' : ''}`}
                      onClick={() => setActivePaymentMethod('Paystack')}
                    >
                      <div className="card-icon">
                        <i className="fa fa-credit-card"></i>
                      </div>
                      <h5>Paystack</h5>
                      <p>Pay with card, bank transfer or USSD</p>
                    </div>

                  {/*   <div
                      className={`payment-method-card ${activePaymentMethod === 'Flutterwave' ? 'active' : ''}`}
                      onClick={() => setActivePaymentMethod('Flutterwave')}
                    >
                      <div className="card-icon">
                        <i className="fa fa-university"></i>
                      </div>
                      <h5>Flutterwave</h5>
                      <p>Pay with card, bank transfer or mobile money</p>
                    </div> */}
                  </div>

                  {/* Payment Summary */}
                  <div className="payment-summary">
                    <div className="summary-item">
                      <span>Base Amount:</span>
                      <span>
                        {Currency}
                        {FormatNumber(skill?.course_code?.fees || 0)}
                      </span>
                    </div>
                    <div className="summary-item">
                      <span>Processing Fee:</span>
                      <span>
                        {Currency}
                        {activePaymentMethod === 'Paystack'
                          ? FormatNumber((amountTopay / 100) - skill?.course_code?.fees)
                          : FormatNumber(amountTopay - skill?.course_code?.fees)}
                      </span>
                    </div>
                    <div className="summary-item total">
                      <span>Total:</span>
                      <span>
                        {Currency}
                        {activePaymentMethod === 'Paystack'
                          ? FormatNumber(amountTopay / 100)
                          : FormatNumber(amountTopay)}
                      </span>
                    </div>
                  </div>



                  {/* Payment Button */}
               {/* activePaymentMethod === 'Paystack' ? (
                    <button
                      className="payment-button"
                      onClick={() => initializePayment({ onSuccess, onClose })}
                    >
                      <i className="fa fa-lock"></i>
                      Pay Now with Paystack
                      <span>{Currency}{FormatNumber(amountTopay / 100)}</span>
                    </button>
                  ) : (
                    <button className="payment-button" onClick={handleFlutterPay}>
                      <i className="fa fa-lock"></i>
                      Pay Now with Flutterwave
                      <span>{Currency}{FormatNumber(amountTopay)}</span>
                    </button>
                  ) */
                  
                  }

<button
                      className="payment-button"
                      onClick={() => initializePayment({ onSuccess, onClose })}
                    >
                      <i className="fa fa-lock"></i>
                      Pay Now with Paystack
                      <span>{Currency}{FormatNumber(amountTopay / 100)}</span>
                    </button>

         {/* <button
                      className="payment-button"
                      onClick={() => handleSubmitPayment(1525, 'Paystack', '12345678902')}
                    >
                      <i className="fa fa-lock"></i>
                      Pay Now with Manual
                      <span>{Currency}{FormatNumber(amountTopay / 100)}</span>
                    </button>   */}

                </div>
              </div>
            </div>

            {/* Right Side Information */}
            <div className="col-lg-4">

            


              <div className="payment-info-card mt-4">
                <div className="payment-info-header">
                  <h5 className="mb-0">Student Information</h5>
                </div>
                <div className="payment-info-body">
                  <div className="payment-info-group">
                    <span className="payment-info-label">Name</span>
                    <span className="payment-info-value">{student.full_name}</span>
                  </div>
                  <div className="payment-info-group">
                    <span className="payment-info-label">Matric Number</span>
                    <span className="payment-info-value">{student.matric_no}</span>
                  </div>
                  <div className="payment-info-group">
                    <span className="payment-info-label">Department</span>
                    <span className="payment-info-value">{student.department}</span>
                  </div>
                  <div className="payment-info-group">
                    <span className="payment-info-label">Faculty</span>
                    <span className="payment-info-value">{student.faculty}</span>
                  </div>
                </div>
              </div>


              <div className="payment-info-card ">
                <div className="payment-info-header">
                  <h5 className="mb-0">Need Help?</h5>
                </div>
                <div className="payment-info-body">

              
                  <p>
                    If you're having trouble with your payment or have questions, please contact our support team:
                  </p>
                  <div className="payment-info-group">
                    <span className="payment-info-label">Email</span>
                    <span className="payment-info-value">{Contact.email}</span>
                  </div>
                  <div className="payment-info-group">
                    <span className="payment-info-label">Phone</span>
                    <span className="payment-info-value">{Contact.telephone}</span>
                  </div>
                </div>
              </div>
             
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Payment;